import React, {PureComponent} from 'react'
import {connect} from 'react-redux'

/* Utils */
import {
  extractCachedUserInfoCookie,
  extractCachedUserInfoJwt,
  getUserInfoJwtToken
} from '../../modules/account/accountUtils'

/* Actions */
import {actionCreators as accountActionCreators} from '../../redux/actions/accountActions'

/* Constants */
import {
  HBUS_READY_EVENT
} from '../../modules/analytics/hbus/hbusConstants'

const hbPageWithUserInfo = (PageComponent) => {
  class PageWithUserInfo extends PureComponent {
    static fetchData = PageComponent.fetchData

    static displayName = PageComponent.displayName + 'WithUserInfo'

    constructor(props) {
      super(props)

      this.userInfoPromiseContext = {}
      this.userInfoPromise = new Promise((resolve, reject) => {
        this.userInfoPromiseContext.resolve = resolve
        this.userInfoPromiseContext.reject = reject
      })
    }

    dispatchCachedUserInfo() {
      const {
        dispatch,
      } = this.props

      let cachedUserInfo = null
      const jwtCookie = getUserInfoJwtToken()
      if (jwtCookie) {
        cachedUserInfo = extractCachedUserInfoJwt()
      } else {
        cachedUserInfo = extractCachedUserInfoCookie()
      }

      if (cachedUserInfo && cachedUserInfo.userId) {
        return dispatch(accountActionCreators.setUserInfo.trigger(cachedUserInfo))
      }

      return Promise.resolve()
    }

    fetchUserInfo() {
      const {
        userInfo,
      } = this.props

      if (!userInfo || (userInfo && !userInfo.sessionId)) {
        const isDispatchCachedUserInfo = this.dispatchCachedUserInfo()
        if (isDispatchCachedUserInfo) {
          isDispatchCachedUserInfo.then(() => {
            this.userInfoPromiseContext.resolve(this.props.userInfo)
          })
        } else {
          window.addEventListener(HBUS_READY_EVENT, () => {
            this.dispatchCachedUserInfo().then(() => {
              this.userInfoPromiseContext.resolve(this.props.userInfo)
            })
          })
        }
      } else {
        this.userInfoPromiseContext.resolve()
      }
    }

    componentDidMount() {
      this.fetchUserInfo()
    }

    render() {
      return (
        <PageComponent
          {...this.props}
          userInfo={this.props.userInfo}
          userInfoPromise={this.userInfoPromise} />
      )
    }
  }

  return connect(mapStateToProps)(PageWithUserInfo)
}

function mapStateToProps(state) {
  const {
    accountState: {
      userInfo
    },
    featureToggleState: {
      appFeatureToggleMap
    }
  } = state

  return {
    userInfo,
    appFeatureToggleMap
  }
}

export default hbPageWithUserInfo
